import request from '@/utils/request';
import {
  get,
  post
} from '@/utils/request2';
const Qs = require('qs');

// /adminHome/login 登录
export const loginApi = params => {
    return request({
        url: '/auth/login',
        method: 'post',
        data: params,
        headers:{
          'Content-Type': 'application/json'
        },
    });
};

// /adminHome/login 登录
export const getInfo = params => {
  return request({
      url: '/auth/userinfo',
      method: 'get',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// ----------电表管理----------

//  /admin/electricity/bill/list 获取账单列表

export const billList = params => {
  return request({
      url: '/admin/electricity/bill/list',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
export const totalNum = params => {
  return request({
      url: '/admin/electricity/bill/totalDegreesAndAmount',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// /bill/batch/all  // 获取所有抄表批次
export const batchAll = params => {
  return request({
      url: '/bill/batch/all',
      method: 'get',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// /company/selectCompanyList 商铺号列表
// export const getRegionList = params => {
//   return request({
//       url: '/admin/electricity/bill/getElectricityOption',
//       method: 'get',
//       data: params,
//       headers:{
//         'Content-Type': 'application/json'
//       },
//   });
// };

//  /admin/electricity/bill/changePrice 修改单价

export const changePrice = params => {
  return request({
      url: '/admin/electricity/bill/changePrice',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// admin/electricity/bill/addBillBatch添加抄表批次
export const addBillBatch = params => {
  return request({
      url: '/admin/electricity/bill/addBillBatch',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};




// ----------账号管理----------
// /admin/user/list  获取用户列表
export const userList = params => {
  return request({
      url: '/admin/user/list',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// /admin/user/save  保存用户信息
export const saveUser = params => {
  return request({
      url: '/admin/user/save',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// /admin/user/delete  删除用户
export const deleteUser = params => {
  return request({
      url: '/admin/user/delete',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// /admin/user/allRole  获取所有角色
export const allRoleList = params => {
  return request({
      url: '/admin/user/allRole',
      method: 'get',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// /index/indexData 企业首页数据统计
export const indexDataApi = params => {
  return request({
      url: 'index/indexData',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// ----------店铺管理----------

// 店铺列表
export const getElectricityList = params => {
  return request({
      url: '/admin/electricity/getElectricityList',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};


export const saveElectricity = params => {
  return request({
      url: '/admin/electricity/saveElectricity',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

export const deleteElectricity = params => {
  return request({
      url: '/admin/electricity/deleteElectricity',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

//是否启用
export const enableElectricity = params => {
  return request({
      url: '/admin/electricity/enableElectricity',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

export const disableElectricity = params => {
  return request({
      url: '/admin/electricity/disableElectricity',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// 获取区域配置
export const getRegions = params => {
  return request({
      url: '/admin/electricity/getRegions',
      method: 'get',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

//管道井配置
// export const getPipingShafts = params => {
//   return request({
//       url: '/admin/electricity/getPipingShafts',
//       method: 'get',
//       data: params,
//       headers:{
//         'Content-Type': 'application/json'
//       },
//   });
// };
export const getPipingShafts = params => get('/admin/electricity/getPipingShafts', params);



// ----------二维码----------
// /admin/electricity/generateQr  生成二维码
export const generateQr = params => {
  return request({
      url: '/admin/electricity/generateQR',
      method: 'get',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// /admin/electricity/downloadQr  下载二维码
export const downloadQr = params => {
  return request({
      url: '/admin/electricity/downloadQR',
      method: 'get',
      data: params,
      responseType: "blob", // 表明返回服务器返回的数据类型
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// /index/newCountList 企业首页数据统计折线图
export const newCountListApi = params => {
  return request({
      url: 'index/newCountList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /index/newUserCountList 数据中心-用户增长情况
export const newUserCountListApi = params => {
  return request({
      url: 'index/newUserCountList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /index/userUseCountList 数据中心-使用人数增长情况
export const userUseCountListApi = params => {
  return request({
      url: 'index/userUseCountList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /index/userSexCount 用户画像-性别分布
export const userSexCountApi = params => {
  return request({
      url: 'index/userSexCount',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /businessCard/selectCustomerList 查询用户列表
export const selectCustomerListApi = params => {
  return request({
      url: 'businessCard/selectCustomerList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /businessCard/getCustomerInfo 查询用户信息
export const getCustomerInfoApi = params => {
  return request({
      url: 'businessCard/getCustomerInfo',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};


// /User/realList 获取实名列表接口
export const getRealNameList = params => {
  return request({
      url: 'User/realList',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// /User/reportList 获取举报列表接口
export const getReportList = params => {
  return request({
      url: 'User/reportList',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};



export const changeReportApi = params => {
  return request({
      url: 'User/changeReport',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /businessCard/selectCustomerListExport 导出用户列表
export const selectCustomerListExportApi = params => {
  return request({
      url: 'businessCard/selectCustomerListExport',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};



// /company/selectCompanyList 查询企业列表
export const selectCompanyListApi = params => {
  return request({
      url: 'company/selectCompanyList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /company/selectAgentCompanyList 查询代理企业列表
export const selectAgentCompanyListApi = params => {
  return request({
      url: 'company/selectAgentCompanyList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /company/getAdminCompanyInfo 查询企业信息
export const getAdminCompanyInfoApi = params => {
  return request({
      url: 'company/getAdminCompanyInfo',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /company/addCompanyService 公司购买名片服务数
export const addCompanyServiceApi = params => {
  return request({
      url: 'company/addCompanyService',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};


export const selectExhibitionListApi = params => {
  return request({
    url: 'showroom/list',
    method: 'get',
    params: params
  });
};

// showroom/save 保存实体展厅
export const addShowroomApi = params => {
  return request({
      url: 'showroom/save',
      // transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
      //   data = Qs.stringify(data);
      //   return data
      // }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// showroom/delete 删除实体展厅
export const deleteShowroomApi = params => {
  return request({
      url: 'showroom/delete',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /adminApi/User/delReal  奖券订单查询接口
// export const delRealApi = params => {
//   return request({
//       url: 'User/delReal',
//       transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
//         data = Qs.stringify(data);
//         return data
//       }],
//       method: 'post',
//       data: params,
//       headers:{
//         'Content-Type': 'application/x-www-form-urlencoded'
//       },
//   });
// };


// export const delRealApi = params => post('User/delReal', params, true);

export const delRealApi = params => {
  return request({
      url: 'User/delReal',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};


// /company/auditCompany 审核公司
export const auditCompanyApi = params => {
  return request({
      url: 'company/auditCompany',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// /goods/systemtypelist 获取平台分类列表接口接口
// export const ptListApi = params => {
//   return request({
//       url: 'goods/systemtypelist',
//       transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
//         data = Qs.stringify(data);
//         return data
//       }],
//       method: 'post',
//       data: params,
//       headers:{
//         'Content-Type': 'application/x-www-form-urlencoded'
//       },
//   });
// };

// /company/selectCompanyListExport 导出企业列表
export const selectCompanyListExportApi = params => {
  return request({
      url: 'company/selectCompanyListExport',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// company/getTemplateDraftList 查询草稿箱
export const getTemplateDraftListApi = params => {
  return request({
      url: 'company/getTemplateDraftList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// company/getTemplateList 查询小程序模板库
export const getTemplateListApi = params => {
  return request({
      url: 'company/getTemplateList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// company/selectAdminList 查询总后台管理员列表
export const selectAdminListApi = params => {
  return request({
      url: 'company/selectAdminList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// company/selectMenuList 查询管理员权限列表
export const selectMenuListApi = params => {
  return request({
      url: 'company/selectMenuList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// company/saveAdmin 新增总/修改后台管理员
export const saveAdminApi = params => {
  return request({
      url: 'company/saveAdmin',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// company/inserAdminRole 设置总后台管理员权限
export const inserAdminRoleApi = params => {
  return request({
      url: 'company/inserAdminRole',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// company/delAdmin 删除管理员
export const delAdminApi = params => {
  return request({
      url: 'company/delAdmin',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// company/configureAgen 设置企业代理权限和代理价格
export const configureAgenApi = params => {
  return request({
      url: 'company/configureAgen',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// Wechat/selectCompanyAccountList 查询公司账号列表
export const selectCompanyAccountListApi = params => {
  return request({
      url: 'Wechat/selectCompanyAccountList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// Wechat/appletCodeManageList 本地小程序版本代码管理列表
export const appletCodeManageListApi = params => {
  return request({
      url: 'Wechat/appletCodeManageList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// Wechat/commit  代码提交到相应小程序
export const commitApi = params => {
  return request({
      url: 'Wechat/commit',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// Wechat/getQrCode 获取体验码
export const getQrCodeApi = params => {
  return request({
      url: 'Wechat/getQrCode',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// Wechat/getLatestAuditStatus 获取审核结果
export const getLatestAuditStatusApi = params => {
  return request({
      url: 'Wechat/getLatestAuditStatus',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// Wechat/submitAudit 提交审核接口
export const submitAuditApi = params => {
  return request({
      url: 'Wechat/submitAudit',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// Wechat/release 发布小程序
export const releaseApi = params => {
  return request({
      url: 'Wechat/release',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// index/selectAdminRecordList 查询管理员操作记录列表
export const selectAdminRecordListApi = params => {
  return request({
      url: 'index/selectAdminRecordList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// notice/selectNoticeList 查询企业公告列表
export const selectNoticeListApi = params => {
  return request({
      url: 'notice/selectNoticeList',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// notice/insertNotice 新增/编辑企业公告信息
export const insertNoticeApi = params => {
  return request({
      url: 'notice/insertNotice',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};

// notice/delNotice 删除企业公告信息
export const delNoticeApi = params => {
  return request({
      url: 'notice/delNotice',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};


export const oneLoginApi = params => {
  return request({
      url: 'home/login/company',
      transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
        data = Qs.stringify(data);
        return data
      }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/x-www-form-urlencoded'
      },
  });
};


export const goodsImportApi = params => {
  return request({
      url: 'goods/import',
      // transformRequest: [function(data) {      //在请求之前对data传参进行格式转换
      //   data = Qs.stringify(data);
      //   return data
      // }],
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'multipart/form-data'
      },
  });
};

// 活动管理start

// 活动管理报名列表
export const listActivityApi = params => {
  return request({
    url: 'ticket/companylist',
    method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 审核
// export const batchAuditActivity = params => post('/ticket/company/audit', params, true);

export const batchAuditActivity = params => {
  return request({
      url: 'ticket/company/audit',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// 备注
export const batchRemarksActivity = params => {
  return request({
      url: 'ticket/company/setremarks',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// 获取文化节报名公司（活动管理用）
export const listActivityCompanyApi = params => {
  return request({
      url: 'ticket/addcompanylist',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 获取文化节报名公司（活动管理、红木圈编辑用）
export const listActivityCompanyApi2 = params => {
  return request({
      url: 'ticket/allcompanylist',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 获取文化节报名人用户
// adminApi/ticket/addcompanyuserlist
export const listActivityUserlistApi = params => {
  return request({
      url: 'ticket/addcompanyuserlist',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 获取文化节报名花园通用户接口
// adminApi/ticket/ticketTimeCompanyTUser
export const listActivityTUser = params => {
  return request({
      url: 'ticket/ticketTimeCompanyTUser',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 报名活动
// adminApi/ticket/company/add
export const addActivity = params => {
  return request({
      url: 'ticket/company/add',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// adminApi/ticket/company/add
export const updateHomeSort = params => {
  return request({
      url: 'company/saveCompanyAddress',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 修改报名花园通用户信息
export const updateActivity = params => {
  return request({
      url: 'ticket/company/updatetuser',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 清除活动报名列表
// ticket/companylist/clean
export const cleanActivity = params => {
  return request({
      url: 'ticket/companylist/clean',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 活动管理end




// 名片管理start

// 活动管理报名列表
export const listCardApi = params => {
  return request({
    url: 'card/list',
    method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 创建/编辑名片
export const addCard = params => {
  return request({
      url: 'card/save',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};
// 删除名片
export const deleteCard = params => {
  return request({
      url: 'card/delete',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// 名片管理end

// ------------------反馈列表-------------
// adminApi/feedback/audit 获取反馈列表接口
export const getFeedbackList = params => {
  return request({
      url: 'feedback/list',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// adminApi/feedback/audit 处理反馈接口
export const updateFeedback = params => {
  return request({
      url: 'feedback/audit',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// adminApi/feedback/delete 删除反馈接口
export const deleteFeedback = params => {
  return request({
      url: 'feedback/delete',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};

// 实体展厅
// 确认导入全部带有vr地址的店铺
export const exportVrStoreListApi = params => {
  return request({
    url: 'showroom/importShowRoom',
    method: 'get',
    params: params
  });
};

// 批量删除实体展厅
export const batchDeleteExhibition = params => {
  return request({
      url: 'showroom/batchDelete',
      method: 'post',
      data: params,
      headers:{
        'Content-Type': 'application/json'
      },
  });
};


// WEBPACK FOOTER //
// ./src/api/api.js